import { useEffect, useState } from 'react';
import { getDaypartingData, DaypartingDashboardData } from '@/services/pmt3DaypartingService';

interface UseDaypartingDataResult {
  data: DaypartingDashboardData | null;
  isLoading: boolean;
  error: Error | null;
}

export function usePmt3DaypartingData(companyName?: string, asin?: string): UseDaypartingDataResult {
  const [data, setData] = useState<DaypartingDashboardData | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!companyName || !asin) {
      setData(null);
      setIsLoading(false);
      setError(null);
      return;
    }

    setIsLoading(true);
    setError(null);

    getDaypartingData(companyName, asin)
      .then((result) => {
        setData(result);
        setError(null);
      })
      .catch((err) => {
        console.error('Error fetching Dayparting data:', err);
        setError(err instanceof Error ? err : new Error(String(err)));
        setData(null);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [companyName, asin]);

  return { data, isLoading, error };
}